import { render, staticRenderFns } from "./publicCourse.vue?vue&type=template&id=38724db5&"
import script from "./publicCourse.vue?vue&type=script&lang=js&"
export * from "./publicCourse.vue?vue&type=script&lang=js&"
import style0 from "./publicCourse.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports